// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITokenResponseDto
 */
export interface ITokenResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ITokenResponseDto
     */
    access_token?: string;
    /**
     * 
     * @type {number}
     * @memberof ITokenResponseDto
     */
    expires_in?: number;
}

/**
 * Check if a given object implements the ITokenResponseDto interface.
 */
export function instanceOfITokenResponseDto(value: object): value is ITokenResponseDto {
    return true;
}

export function ITokenResponseDtoFromJSON(json: any): ITokenResponseDto {
    return ITokenResponseDtoFromJSONTyped(json, false);
}

export function ITokenResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITokenResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'access_token': json['access_token'] == null ? undefined : json['access_token'],
        'expires_in': json['expires_in'] == null ? undefined : json['expires_in'],
    };
}

export function ITokenResponseDtoToJSON(json: any): ITokenResponseDto {
    return ITokenResponseDtoToJSONTyped(json, false);
}

export function ITokenResponseDtoToJSONTyped(value?: ITokenResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access_token': value['access_token'],
        'expires_in': value['expires_in'],
    };
}

